import { apiSlice } from "./apiSlice";

export const milestoneSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all Milestone list
        getMilestoneList: builder.query({
            query: ({ params, pid }) => ({
                url: `ProjectMilestone/${pid}/milestones`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllMilestone"],
        }),

        // Create new Milestone
        createMilestone: builder.mutation({
            query: ({ body }) => ({
                url: `ProjectMilestone`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllMilestone"],
        }),

        // Update Milestone
        updateMilestone: builder.mutation({
            query: ({ body }) => ({
                url: `ProjectMilestone`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["AllMilestone"],
        }),

        // Delete Milestone
        deleteMilestone: builder.mutation({
            query: (id) => ({
                url: `ProjectMilestone/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllMilestone']
        }),
    })
})

export const { useGetMilestoneListQuery, useLazyGetMilestoneListQuery, useCreateMilestoneMutation, 
    useUpdateMilestoneMutation, useDeleteMilestoneMutation } = milestoneSlice;
